import cmkReducers from "./reducers/index";
import createSagaMiddleware from 'redux-saga';
import thunk from "redux-thunk";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore } from 'redux-persist';
import sagas from '../middlewares/sagas';

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
    cmkReducers,
    composeWithDevTools(
        applyMiddleware(thunk),
        applyMiddleware(sagaMiddleware),
    )
);

persistStore(store);
sagaMiddleware.run(sagas);

export const getPersonById = (person_id) => {
    return store.getState().cmk.herapists.filter(therapist => therapist.id === person_id).shift()
};

export const getHourByValue = (hour_value) => {
    return store.getState().cmk.plan_hours.filter(hour => hour.start === hour_value).shift()
};




// WEBPACK FOOTER //
// ./src/store/helpers.js